export * from './connected-asset-thumbnail';
